<template>
  <NavBar />
  <router-view v-slot="{ Component }">
    <transition name="page" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  <Footer />

  <button class="back-top" :class="{ show: showTop }" aria-label="回到顶部" @click="scrollTop">
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M12 19V5m-6 6 6-6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import NavBar from '@/components/layout/NavBar.vue'
import Footer from '@/components/layout/Footer.vue'

const route = useRoute()
const showTop = ref(false)
let observer = null
let revealTimer = null

const onScroll = () => {
  showTop.value = window.scrollY > 700
}

/* 观察滚动显现元素 */
const observeReveal = () => {
  if (observer) observer.disconnect()
  observer = new IntersectionObserver(
    entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in')
          observer.unobserve(e.target)
        }
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  )
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el))
}

/* 页面过渡( out-in )后新 DOM 才插入，分多次兜底扫描 */
const scheduleReveal = () => {
  clearTimeout(revealTimer)
  ;[60, 220, 520].forEach((t, i) => {
    setTimeout(() => observeReveal(), t + i * 120)
  })
}

const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

watch(
  () => route.fullPath,
  () => scheduleReveal(),
  { immediate: true }
)

onMounted(() => window.addEventListener('scroll', onScroll, { passive: true }))
onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
  clearTimeout(revealTimer)
  if (observer) observer.disconnect()
})
</script>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.24s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}

.back-top {
  position: fixed;
  right: 28px;
  bottom: 34px;
  z-index: 90;
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand2);
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid var(--c-line2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 12px 32px -10px rgba(35, 66, 133, 0.3);
  opacity: 0;
  transform: translateY(14px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.back-top.show {
  opacity: 1;
  transform: none;
  pointer-events: auto;
}
.back-top:hover {
  color: #fff;
  background: var(--grad-main);
  border-color: transparent;
}
.back-top svg {
  width: 19px;
  height: 19px;
}
</style>
